import { HYGRAPH_DASHBOARD_HEALTH_REPORT_ID } from 'constants/hygraphShemeId';
import { colorsFragment, kitPriceFragment, richTextFragment } from 'petdna-lib-uicomponents/hygraph';

export const GET_DASHBOARD_HEALTH_REPORT_QUERY = `query DashboardHealthReport($id: ID = "${HYGRAPH_DASHBOARD_HEALTH_REPORT_ID}", $kitsSaleCountry: SaleCountry!) {
  dashboardHealthReport(where: { id: $id }) {
    title
    description
    buttonText
    healthTraitResultTypes {
      id
      traitPredictionId
      titlePlural
      description {
        ${richTextFragment}
      }
      backgroundColor {
        ${colorsFragment}
      }
      textColor {
        ${colorsFragment}
      }
    }
    unlock {
      title
      description {
        ${richTextFragment}
      }
      buttonText
    }
    healthReportPrices(where: {saleCountry: $kitsSaleCountry}) {
      ${kitPriceFragment}
    }
  }
}
`;
